import React, { useState } from "react";
import { Link } from "react-router-dom";

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Should I record with my laptop or phone?",
      answer:
        "Our platform accepts digital audio from both laptops and mobile devices.",
    },
    {
      question: "What apps should I use for recording?",
      answer:
        "You can use apps like Audacity, GarageBand, or any voice recorder app on your phone.",
    },
    {
      question: "How do I learn how to use it?",
      answer:
        "We provide tutorials and documentation on our website. You can also reach out to our support team for assistance.",
    },
    {
      question: "How many campaigns can I record for?",
      answer:
        "You can record for as many campaigns as you like. There are no limitations.",
    },
    {
      question: "How much does Tabletop Recorder cost?",
      answer:
        "Pricing varies based on how many hours of audio you need to upload.",
      isPricing: true,
    },
  ];

  const toggleAccordion = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="mx-auto mx-4 md:mx-16 p-4">
      {faqs.map((faq, index) => (
        <div key={index} className="mb-2 bg-white/10 rounded-md border">
          <button
            className="w-full text-left p-4 focus:outline-none flex justify-between items-center"
            onClick={() => toggleAccordion(index)}>
            {faq.question}
            <svg
              className={`w-5 h-5 transition-transform transform ${
                openIndex === index ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="#D9951C"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          {openIndex === index && (
            <>
              <hr className="mx-4" />
              <div className="p-4 mt-1 text-sm text-white/80">
                {faq.answer}
                {faq.isPricing && (
                  <div className="mt-4">
                    <Link
                      to="/login"
                      className="bg-primary hover:bg-primary-light text-white py-2 px-6 rounded-lg font-semibold transition-colors inline-block"
                    >
                      Sign In to See Pricing Options
                    </Link>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
